import React from 'react';
import Header, { HeaderLeft } from '../../../layout/Header/Header';
import CommonHeaderRight from './CommonHeaderRight';

const UserManagementHeader = () => {
	return (
		<Header>
			<HeaderLeft className='h4 mb-0 fw-bold'>User management</HeaderLeft>
			<CommonHeaderRight />
		</Header>
	);
};

export default UserManagementHeader;
